<template>
    <div class="card">
        <div class="card-head">
            <div>
                <div class="card-title">{{ payload.title }}</div>
                <div class="card-sub">{{ payload.subtitle }}</div>
            </div>
            <div v-if="payload.tabs" class="tabs">
                <span
                    v-for="(tab, idx) in payload.tabs"
                    :key="idx"
                    class="tab"
                    :class="{ 'tab--active': idx === payload.activeTab }"
                >
                    {{ tab }}
                </span>
            </div>
        </div>

        <div class="table-wrap">
            <table class="tbl">
                <thead>
                    <tr>
                        <th
                            v-for="col in payload.columns"
                            :key="col.id"
                            :class="{ num: col.align === 'right' }"
                            :style="col.width ? { width: col.width } : null"
                        >
                            {{ col.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rIdx) in payload.rows" :key="rIdx">
                        <td
                            v-for="col in payload.columns"
                            :key="`${rIdx}-${col.id}`"
                            :class="cellClass(col, row)"
                        >
                            <strong v-if="col.id === 'brand'">{{ row[col.id] }}</strong>
                            <template v-else>{{ row[col.id] }}</template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="payload.footer" class="mini">{{ payload.footer }}</div>
    </div>
</template>

<script setup>
defineProps({
    payload: { type: Object, required: true },
})

function cellClass(col, row) {
    const result = []
    if (col.align === 'right') result.push('num')
    if (col.id === 'yoy' && row.yoyTone) result.push(`tone-${row.yoyTone}`)
    return result
}
</script>

<style scoped>
.card {
    background: white;
    border: 1px solid #E8E6E0;
    border-radius: 10px;
    padding: 16px;
    margin: 12px 0;
}

.card-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
    gap: 12px;
    flex-wrap: wrap;
}

.card-title {
    font-size: 13px;
    font-weight: 600;
    color: #23282C;
}

.card-sub {
    font-size: 11px;
    color: #888780;
    margin-top: 2px;
}

.tabs {
    display: flex;
    gap: 0;
}

.tab {
    font-size: 11px;
    padding: 6px 12px;
    color: #888780;
    border-bottom: 2px solid transparent;
}

.tab--active {
    color: #23282C;
    border-bottom-color: #0F6E56;
    font-weight: 600;
}

.table-wrap {
    width: 100%;
    overflow-x: auto;
}

.tbl {
    width: 100%;
    border-collapse: collapse;
    font-size: 12.5px;
}

.tbl th {
    text-align: left;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #888780;
    padding: 8px 6px;
    border-bottom: 1px solid #E8E6E0;
}

.tbl td {
    padding: 9px 6px;
    border-bottom: 1px solid #F1EFE8;
    color: #23282C;
}

.tbl tr:last-child td {
    border-bottom: none;
}

.tbl .num {
    text-align: right;
    font-variant-numeric: tabular-nums;
}

.tone-pos {
    color: #0F6E56;
    font-weight: 600;
}

.tone-neg {
    color: #E30613;
    font-weight: 600;
}

.tone-zero {
    color: #888780;
}

.mini {
    font-size: 10px;
    color: #888780;
    margin-top: 10px;
}
</style>
